import i18n from "i18next";
import * as Yup from "yup";

export const EmailValidation = () => {
  return Yup.string()
    .email(`${i18n.t("applicationForm.commons.emailErrors.invalid")}`)
    .required(`${i18n.t("applicationForm.commons.emailErrors.required")}`);
};
